import moment from "moment";

export default {
    data() {
        return {
            mensaje: '',
            tipo:'',
            mostrar: false,
            loader: null
        };
    },
    methods: {
        convertDate: function(fecha) {
            if(fecha){
                let date = JSON.stringify(fecha)
                date = date.slice(1,11)
                return date
            }
            return null
        },
        _checkRequired(instance, fields) {
            for(var field in fields) {
                let val = instance[fields[field]]
                if(!val || (typeof val == String && val == '')) {

                    return false
                }
            }
            return true
        },
        _checkPerfil(perfil){
            let payload = sessionStorage.getItem('payload');
            let userMetadata = JSON.parse(atob(payload));
            let perfiles = userMetadata.perfiles;
            return perfiles.includes(perfil)
        },
        _checkLogin(){
            if(sessionStorage.getItem('usuario') != null)
                return true
            else
                return false
        },
        _concatDateTime: function (fecha, hora){
            var momentObj = moment(fecha + hora, 'YYYY-MM-DDLT');
            return momentObj.format('YYYY-MM-DD HH:mm:ss');
        },
        activeSpinner() {
            this.loader = this.$loading.show({loader: 'dots'});
        },
        desactiveSpinner() {
            this.loader.hide();
        }
    }
};
